import { vec2, vec3, vec4, mat4, mat3, quat } from "gl-matrix";
import { MathConst } from "./wContants.js";

class wMath {
    constructor() { }

    static polarToCartesian(azimuth, theta) {
        var v = vec3.create();
        v[0] = Math.cos(theta) * Math.sin(azimuth);
        v[1] = Math.sin(theta);
        v[2] = Math.cos(theta) * Math.cos(azimuth);
        return v;
    }

    static cartesianToPolar(v) {
        var res = vec2.fromValues(0.0, 0.0);
        const l = vec3.length(v);
        if (l < 0.00001) return res;

        let tmp = vec3.fromValues(v[0] / l, v[1] / l, v[2] / l);
        res[0] = Math.atan2(tmp[0], tmp[2]);
        res[1] = Math.asin(tmp[1]);
        return res;
    }

    static angleWrappingTwoPi(ang) {
        let angle = ang;

        if (angle > MathConst.fTWO_PI) {
            angle = angle - MathConst.fTWO_PI;
        }

        if (angle < 0.0) {
            angle += MathConst.fTWO_PI;
        }
        return angle;
    }

    // creates a unit quat that rotates from vFrom to Vto
    static getQuatFromUnitVectors(vFrom, vTo) {
        var result = quat.create();
        let r = vec3.dot(vFrom, vTo) + 1.0;
        let q = quat.create();

        if (r < 0.00001) {
            r = 0.0;
            if (Math.abs(vFrom[0]) > Math.abs(vFrom[2])) {
                q[0] = -vFrom[1];
                q[1] = vFrom[0];
                q[2] = 0.0;
                q[3] = r;
            } else {
                q[0] = 0.0;
                q[1] = -vFrom[2];
                q[2] = vFrom[1];
                q[3] = r;
            }
        } else {
            q[0] = vFrom[1] * vTo[2] - vFrom[2] * vTo[1];
            q[1] = vFrom[2] * vTo[0] - vFrom[0] * vTo[2];
            q[2] = vFrom[0] * vTo[1] - vFrom[1] * vTo[0];
            q[3] = r;
        }

        quat.normalize(result, q);
        return result;
    }

    static getUnitQuat() { }

    /*static rayPlaneIntersection(ray, plane){

        const  DN = vec3::dot(ray.getDirection(),glm::vec3(planeEq_.x, planeEq_.y, planeEq_.z));
    if (std::fabs(DN) < Fundament::fEps) return false;

    intersection.x = (-planeEq_.w - glm::dot(ray.getOrigin(), glm::vec3(planeEq_.x, planeEq_.y, planeEq_.z))) / DN;
    return (intersection.x >= 0.0f);

    }*/

    static printVec3(v) {
        console.log("(" + v[0] + "," + v[1] + "," + v[2] + ")");
    }

    static printVec4(v) {
        console.log("(" + v[0] + "," + v[1] + "," + v[2] + "," + v[3] + ")");
    }

        /* use clampF instead
    static clamp(value, valueMin, valueMax) {
        return Math.max(Math.min(value, valueMax), valueMin);
    }
    */

    static smoothStep(edge0, edge1, x) {
        let t = this.clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);
        return t * t * (3.0 - 2.0 * t);
    }

    static vec2X(v) { return v[0]; }
    static vec2Y(v) { return v[1]; }
    static vec2GetOrthogonal(v) { return vec2.fromValues(-v[1], v[0]); }
    static vec2GetOrthogonalNegative(v) { return vec2.fromValues(v[1], -v[0]); }

    static vec2Add(v0, v1) {
        var v = vec2.create();
        vec2.add(v, v0, v1);
        return v;
    }

    static vec2Sub(v0, v1) {
        var v = vec2.create();
        vec2.sub(v, v0, v1);
        return v;
    }

    static vec2Scale(v0, s) {
        var v = vec2.create();
        vec2.scale(v, v0, s);
        return v;
    }

    static vec2Normalize(v0) {
        var v = vec2.create();
        vec2.normalize(v, v0);
        return v;
    }

    static vec3X(v) { return v[0]; }
    static vec3Y(v) { return v[1]; }
    static vec3Z(v) { return v[2]; }

    // returns a vec3 with random values in the range [minValue, maxValue]
    static getRandomVec3(minValue, maxValue) {
        const valueRange = maxValue - minValue;
        var randVec = vec3.fromValues(Math.random() * valueRange + minValue, Math.random() * valueRange + minValue, Math.random() * valueRange + minValue);
        return randVec;
    }

    static vec3Normalize(v0) {
        var v = vec3.create();
        vec3.normalize(v, v0);
        return v;
    }

    static vec3Add(v0, v1) {
        var v = vec3.create();
        vec3.add(v, v0, v1);
        return v;
    }

    static vec3Sub(v0, v1) {
        var v = vec3.create();
        vec3.sub(v, v0, v1);
        return v;
    }

    static vec3Mult(v0, v1) {
        var v = vec3.create();
        vec3.multiply(v, v0, v1);
        return v;
    }

    static vec3Scale(v0, s) {
        var v = vec3.create();
        vec3.scale(v, v0, s);
        return v;
    }

    static vec3Max(v0, v1) {
        var v = vec3.fromValues(Math.max(v0[0], v1[0]), Math.max(v0[1], v1[1]), Math.max(v0[2], v1[2]));
        return v;
    }

    static vec3Min(v0, v1) {
        var v = vec3.fromValues(Math.min(v0[0], v1[0]), Math.min(v0[1], v1[1]), Math.min(v0[2], v1[2]));
        return v;
    }

    static vec3MaxValue(v) {
        return Math.max(Math.max(v[0], v[1]), v[2]);
    }

    static vec3MinValue(v) {
        return Math.min(Math.min(v[0], v[1]), v[2]);
    }

    static addVec3ToFloatArray(v3, vertexArray, index) {
        for (let i = 0; i < 3; i++) {
            vertexArray[index + i] = v3[i];
        }
    }

    static vec4X(v) { return v[0]; }
    static vec4Y(v) { return v[1]; }
    static vec4Z(v) { return v[2]; }
    static vec4W(v) { return v[3]; }

    static vec4FromVec3(v3) {
        return vec4.fromValues(v3[0], v3[1], v3[2], 0.0);
    }

    static vec4Add(v0, v1) {
        var v = vec4.create();
        vec4.add(v, v0, v1);
        return v;
    }

    static vec4Sub(v0, v1) {
        var v = vec4.create();
        vec4.sub(v, v0, v1);
        return v;
    }

    static vec4Mult(v0, v1) {
        var v = vec4.create();
        vec4.multiply(v, v0, v1);
        return v;
    }

    static vec4Scale(v0, s) {
        var v = vec4.create();
        vec4.scale(v, v0, s);
        return v;
    }

    static setMat3ToZero(mat) {
        for (let i = 0; i < 9; i++) {
            mat[i] = 0.0;
        }
    }

    static outerProduct(v0, v1) {
        var outerProd = mat3.fromValues(
            v0[0] * v1[0],
            v0[0] * v1[1],
            v0[0] * v1[2],

            v0[1] * v1[0],
            v0[1] * v1[1],
            v0[1] * v1[2],

            v0[2] * v1[0],
            v0[2] * v1[1],
            v0[2] * v1[2]
        );
        return outerProd;
    }

    static mat3Add(mat, matAdd) {
        for (let i = 0; i < 9; i++) {
            mat[i] += matAdd[i];
        }
    }

    static mat3Scale(mat, s) {
        for (let i = 0; i < 9; i++) {
            mat[i] *= s;
        }
    }

    static mat3GetRow(mat, index) {
        return vec3.fromValues(mat[index * 3], mat[(index * 3) + 1], mat[(index * 3) + 2]);
    }

    static mat3GetCol(mat, index) {
        return vec3.fromValues(mat[index], mat[index + 3], mat[index + 6]);
    }


    static setMat4ToZero(mat) {
        for (let i = 0; i < 16; i++) {
            mat[i] = 0.0;
        }
    }

    static mat4GetRow(mat, index) {
        return vec4.fromValues(mat[index * 4], mat[(index * 4) + 1], mat[(index * 4) + 2], mat[(index * 4) + 3]);
    }

    static mat4GetCol(mat, index) {
        return vec4.fromValues(mat[index], mat[index + 4], mat[index + 8], mat[index + 12]);
    }

    static mat4Mult(m0, m1) {
        var m = mat4.create();
        mat4.multiply(m, m0, m1);
        return m;
    }

    static mat4FromMat3(m3) {
        var m = mat4.create();
        m[0] = m3[0];
        m[1] = m3[1];
        m[2] = m3[2];

        m[4] = m3[3];
        m[5] = m3[4];
        m[6] = m3[5];

        m[8] = m3[6];
        m[9] = m3[7];
        m[10] = m3[8];
        return m;
    }

    static addVec4ToFloatArray(v4, vertexArray, index) {
        for (let i = 0; i < 4; i++) {
            vertexArray[index + i] = v4[i];
        }
    }

    static perspectiveZO(fovy, aspect, near, far) {
        var out = mat4.create();
        const f = 1.0 / Math.tan(fovy / 2);
        out[0] = f / aspect;
        out[1] = 0.0;
        out[2] = 0.0;
        out[3] = 0.0;
        out[4] = 0.0;
        out[5] = f;
        out[6] = 0.0;
        out[7] = 0.0;
        out[8] = 0.0;
        out[9] = 0.0;
        out[11] = -1;
        out[12] = 0.0;
        out[13] = 0.0;
        out[15] = 0.0;

        if (far != null && far !== Infinity) {
            const nf = 1 / (near - far);
            out[10] = far * nf;
            out[14] = far * near * nf;
        } else {
            out[10] = -1.0;
            out[14] = -near;
        }

        return out;
    }

    static vectorProjection(v, n) {
        let tmp = vec3.create();
        vec3.scale(tmp, n, vec3.dot(n, v));
        vec3.scale(tmp, tmp, 1.0 / vec3.dot(n, n));
        return tmp;
    }

    static vectorProjectionV2(v, n) {
        let tmp = vec2.create();
        vec2.scale(tmp, n, vec2.dot(n, v));
        vec2.scale(tmp, tmp, 1.0 / vec2.dot(n, n));
        return tmp;
    }

    static gramOrthonomalization(v0, v1, v2) {
        let u0 = vec3.create();
        vec3.copy(u0, v0);

        let e0 = vec3.create();
        vec3.normalize(e0, u0);

        let u1 = vec3.create();
        vec3.sub(u1, v1, this.vectorProjection(v1, v0));

        let e1 = vec3.create();
        vec3.normalize(e1, u1);

        let u2 = vec3.create();
        vec3.subtract(u2, v2, this.vectorProjection(v2, v0));
        vec3.subtract(u2, u2, this.vectorProjection(v2, v1));

        let e2 = vec3.create();
        vec3.normalize(e2, u2);

        return [e0, e1, e2];
    }

    static frisvadONB(n) {
        // http://orbit.dtu.dk/files/126824972/onb_frisvad_jgt2012_v2.pdf

        if (n[2] < -0.9999999) {
            // Handle the singularity
            let b1 = vec3.fromValues(0.0, -1.0, 0.0);
            let b2 = vec3.fromValues(-1.0, 0.0, 0.0);
            return [b1, b2];
        }
        let a = 1.0 / (1.0 + n[2]);
        let b = -n[0] * n[1] * a;
        let b1 = vec3.fromValues(1.0 - n[0] * n[0] * a, b, -n[0]);
        let b2 = vec3.fromValues(b, 1.0 - n[1] * n[1] * a, -n[1]);

        return [b1, b2];
    }

    static getIndexOfMinComponent(v) {
        return v[0] < v[1] && v[0] < v[2] ? 0 : v[1] < v[2] ? 1 : 2;
    }

    static clamp(v, minVal, maxVal) {
        let vOut = vec3.create();
        vOut[0] = Math.min(Math.max(v[0], minVal), maxVal);
        vOut[1] = Math.min(Math.max(v[1], minVal), maxVal);
        vOut[2] = Math.min(Math.max(v[2], minVal), maxVal);
        return vOut;
    }

    static clampF(f, minVal, maxVal) {
        return Math.min(Math.max(f, minVal), maxVal);
    }

    static getSortedIndices(v) {
        var indices = [0, 1, 2];
        for (let i = 0; i < 3; i++) {
            for (let j = i + 1; j < 3; j++) {
                if (v[indices[i]] > v[indices[j]]) {
                    const tmp = indices[i];
                    indices[i] = indices[j];
                    indices[j] = tmp;
                }
            }
        }
        return indices;
    }

    static calculateEigenValues(symMat3, eigenValues) {

        let m11 = symMat3[0];
        let m12 = symMat3[1];
        let m13 = symMat3[2];

        let m22 = symMat3[4];
        let m23 = symMat3[5];
        let m33 = symMat3[8];

        var eigenVectors = [[1.0, 0.0, 0.0], [0.0, 1.0, 0.0], [0.0, 0.0, 1.0]]; // creates identity

        for (let a = 0; a < 16; a++) {
            // Exit if off-diagonal entries small enough.
            if ((Math.abs(m12) < MathConst.fEps) && (Math.abs(m13) < MathConst.fEps) && (Math.abs(m23) < MathConst.fEps)) break;

            // Annihilate (1,2) entry.
            if (m12 != 0.0) {
                let u = (m22 - m11) * 0.5 / m12;
                let u2 = u * u;
                let u2p1 = u2 + 1.0;
                let t = (u2p1 != u2) ? ((u < 0.0) ? -1.0 : 1.0) * (Math.sqrt(u2p1) - Math.abs(u)) : 0.5 / u;
                let c = 1.0 / Math.sqrt(t * t + 1.0);
                let s = c * t;
                m11 -= t * m12;
                m22 += t * m12;
                m12 = 0.0;

                const tmp = c * m13 - s * m23;
                m23 = s * m13 + c * m23;
                m13 = tmp;

                for (let i = 0; i < 3; i++) {
                    const temp = c * eigenVectors[i][0] - s * eigenVectors[i][1];
                    eigenVectors[i][1] = s * eigenVectors[i][0] + c * eigenVectors[i][1];
                    eigenVectors[i][0] = temp;
                }
            }

            // Annihilate (1,3) entry.
            if (m13 != 0.0) {
                let u = (m33 - m11) * 0.5 / m13;
                let u2 = u * u;
                let u2p1 = u2 + 1.0;
                let t = (u2p1 != u2) ? ((u < 0.0) ? -1.0 : 1.0) * (Math.sqrt(u2p1) - Math.abs(u)) : 0.5 / u;
                let c = 1.0 / Math.sqrt(t * t + 1.0);
                let s = c * t;

                m11 -= t * m13;
                m33 += t * m13;
                m13 = 0.0;

                const tmp = c * m12 - s * m23;
                m23 = s * m12 + c * m23;
                m12 = tmp;

                for (let i = 0; i < 3; i++) {
                    const temp = c * eigenVectors[i][0] - s * eigenVectors[i][2];
                    eigenVectors[i][2] = s * eigenVectors[i][0] + c * eigenVectors[i][2];
                    eigenVectors[i][0] = temp;
                }
            }

            // Annihilate (2,3) entry.
            if (m23 != 0.0) {
                let u = (m33 - m22) * 0.5 / m23;
                let u2 = u * u;
                let u2p1 = u2 + 1.0;
                let t = (u2p1 != u2) ? ((u < 0.0) ? -1.0 : 1.0) * (Math.sqrt(u2p1) - Math.abs(u)) : 0.5 / u;
                let c = 1.0 / Math.sqrt(t * t + 1.0);
                let s = c * t;

                m22 -= t * m23;
                m33 += t * m23;
                m23 = 0.0;

                const tmp = c * m12 - s * m13;
                m13 = s * m12 + c * m13;
                m12 = tmp;

                for (let i = 0; i < 3; i++) {
                    const temp = c * eigenVectors[i][1] - s * eigenVectors[i][2];
                    eigenVectors[i][2] = s * eigenVectors[i][1] + c * eigenVectors[i][2];
                    eigenVectors[i][1] = temp;
                }
            }
        }

        eigenValues[0] = m11;
        eigenValues[1] = m22;
        eigenValues[2] = m33;

        // sort the out put by eigenvalues in ascending order
        var sortedIndices = wMath.getSortedIndices(eigenValues);
        var tmp0 = vec3.create();
        vec3.copy(tmp0, eigenValues);

        var tmp1 = mat3.fromValues(
            eigenVectors[0][0], eigenVectors[0][1], eigenVectors[0][2],
            eigenVectors[1][0], eigenVectors[1][1], eigenVectors[1][2],
            eigenVectors[2][0], eigenVectors[2][1], eigenVectors[2][2]);

        var sortedEigenVectors = mat3.create();

        eigenValues[0] = tmp0[sortedIndices[0]];
        eigenValues[1] = tmp0[sortedIndices[1]];
        eigenValues[2] = tmp0[sortedIndices[2]];

        sortedEigenVectors[0] = tmp1[sortedIndices[0]];
        sortedEigenVectors[1] = tmp1[sortedIndices[0] + 3];
        sortedEigenVectors[2] = tmp1[sortedIndices[0] + 6];

        sortedEigenVectors[3] = tmp1[sortedIndices[1]];
        sortedEigenVectors[4] = tmp1[sortedIndices[1] + 3];
        sortedEigenVectors[5] = tmp1[sortedIndices[1] + 6];

        sortedEigenVectors[6] = tmp1[sortedIndices[2]];
        sortedEigenVectors[7] = tmp1[sortedIndices[2] + 3];
        sortedEigenVectors[8] = tmp1[sortedIndices[2] + 6];

        return sortedEigenVectors;
    }

    //Van der Corput radical inverse
    static radicalInverse_VdC(i) {
        var bits = new Uint32Array(1);
        bits[0] = i;
        bits[0] = ((bits[0] << 16) | (bits[0] >> 16)) >>> 0;
        bits[0] = ((bits[0] & 0x55555555) << 1) | ((bits[0] & 0xAAAAAAAA) >>> 1) >>> 0;
        bits[0] = ((bits[0] & 0x33333333) << 2) | ((bits[0] & 0xCCCCCCCC) >>> 2) >>> 0;
        bits[0] = ((bits[0] & 0x0F0F0F0F) << 4) | ((bits[0] & 0xF0F0F0F0) >>> 4) >>> 0;
        bits[0] = ((bits[0] & 0x00FF00FF) << 8) | ((bits[0] & 0xFF00FF00) >>> 8) >>> 0;
        return bits[0] * 2.3283064365386963e-10; // / 0x100000000 or / 4294967296
    }

    static hammersley(i, n) {
        return [i / n, wMath.radicalInverse_VdC(i)];
    }

    static isPowerOfTwo(x) {
        return (Math.log2(x) % 1 === 0);
    }

    static lineLineIntersection(
        line0x0, line0y0, line0x1, line0y1,
        line1x0, line1y0, line1x1, line1y1) {

        const x1 = line0x0;
        const y1 = line0y0;

        const x2 = line0x1;
        const y2 = line0y1;

        const x3 = line1x0;
        const y3 = line1y0;

        const x4 = line1x1;
        const y4 = line1y1;

        const det = ((x4 - x3) * (y1 - y2)) - ((x1 - x2) * (y4 - y3));

        if (det == 0.0) return -1;

        const invDet = 1.0 / det;
        let t = (((y3 - y4) * (x1 - x3)) + ((x4 - x3) * (y1 - y3))) * invDet;
        const l2T = (((y1 - y2) * (x1 - x3)) + ((x2 - x1) * (y1 - y3))) * invDet;

        let validT = (t >= 0.0 && t <= 1.0 && l2T > 0.0 && l2T <= 1.0);
        t = (validT) ? t : -1.0;

        return t;
    }

    static calculateWindingNumber2D(point, polygon) {

        const L0 = vec2.fromValues(point[0], point[1]);
        const L1 = vec2.fromValues(L0[0] + 1000.0, L0[1]); // perhaps calculate polygon bounding box, but 1000 has to do for now
        let windingNumber = 0;

        for (let i = 0; i < polygon.length; i++) {
            const P0 = polygon[i];
            const P1 = (i < polygon.length - 1) ? polygon[i + 1] : polygon[0];

            if (this.lineLineIntersection(
                L0[0], L0[1],
                L1[0], L1[1],
                P0[0], P0[1],
                P1[0], P1[1]
            ) >= 0.0) {
                windingNumber++;
            }

        }
        return windingNumber;
    }

    static isPointLeft(A, B, p) // http://geomalgorithms.com/a03-_inclusion.html
    {
        return ((B[0] - A[0]) * (p[1] - A[1]) - (p[0] - A[0]) * (B[1] - A[1])) >= 0.0;
    }

    // return 0 == outside, 1 == inside.
    static getWindingNumber(P, polygon) {
        if (polygon.length == 0) return 1;

        let windingNumber = 0;
        const vertexCount = polygon.length;

        for (let i = 0; i < vertexCount; i++) {
            const A = polygon[i];
            const B = polygon[(i + 1) % vertexCount];

            if (A[1] <= P[1]) // start y <= P[1]
            {
                if (B[1] > P[1]) // an upward crossing
                {
                    if (this.isPointLeft(A, B, P))  // P left of  edge
                    {
                        ++windingNumber;
                    }
                }
            }
            else {
                if (B[1] <= P[1]) // start y > P.y (no test needed)
                {
                    if (!this.isPointLeft(A, B, P)) // a downward crossing
                    {
                        --windingNumber; // have  a valid down intersect
                    }
                }
            }
        }
        return windingNumber;
    }

    // assume planeEq is normalized
    static getSignedDistanceToPlane(pos, planeEq) {
        return vec3.dot(pos, vec3.fromValues(planeEq[0], planeEq[1], planeEq[2])) + planeEq[3];
    }

    static getPlaneOrigin(planeEq) {
        let origo = vec3.fromValues(0.0, 0.0, 0.0);
        let signedDistToPlane = this.getSignedDistanceToPlane(origo, planeEq);
        return this.vec3Add(origo, vec3.fromValues(planeEq[0] * signedDistToPlane, planeEq[1] * signedDistToPlane, planeEq[2] * signedDistToPlane));
    }

    // web mercator projection
    static LatLongitudeToPosition(lat, lng, tileSize) {
        const lambda2 = lng * MathConst.fDegToRad;
        const phi2 = lat * MathConst.fDegToRad;;
        const x = (tileSize * (lambda2 + MathConst.fPI)) / (2.0 * MathConst.fPI);
        const y = (tileSize * (MathConst.fPI + Math.log(Math.tan(MathConst.fPI_QUARTER + phi2 * 0.5)))) / (2.0 * MathConst.fPI);
        return vec2.fromValues(x, y);
    }

    static positionToLatLongitude(pos, tileSize) {
        const lambda2 = (pos[0] / tileSize) * (2.0 * MathConst.fPI) - MathConst.fPI;
        const phi2 = 2.0 * (Math.atan(Math.exp((pos[1] / tileSize) * (2.0 * MathConst.fPI) - MathConst.fPI)) - MathConst.fPI_QUARTER);
        return vec2.fromValues(lambda2 * MathConst.fRadToDeg, phi2 * MathConst.fRadToDeg);
    }

}
export { wMath };
